import { useCallback } from "react";

export const useScrollTo = (carouselRef) =>
  useCallback(
    (offset) => {
      carouselRef.current?.scrollBy({ left: offset, behavior: "smooth" });
    },
    [carouselRef],
  );
